import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { RANGER_TYPE, RangerFirearmAssignmentLog } from 'assets-model';


@Component({
  selector: 'app-ranger-firearm-assignment-log-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class RangerFirearmAssignmentLogEditorComponent extends CrudEditComponent<RangerFirearmAssignmentLog, string> implements OnInit {

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    //this.actions = [];
  }

  backRouteFallback(): any[] {
    const rangerId = this.item?.rangerId ?? this.route.snapshot.queryParams.rangerId;
    return rangerId != null ? [...RANGER_TYPE.editRouteBase, rangerId] : super.backRouteFallback();
  }


}






